import React, { HTMLAttributes, ReactNode } from "react";
import { createStyles, makeStyles } from "@material-ui/core";

interface FListProps extends HTMLAttributes<HTMLDivElement> {
    // ID
    id: string;
    // スライド番号
    slideTitle: ReactNode;
    // Index・Tip内容
    description: ReactNode;
    // Index・Tipを削除するイベント
    deleteClick: (id: string) => void;
    // Index・Tipを編集するイベント
    editClick: (id: string) => void;
}

const useStyles = makeStyles(() =>
    createStyles({
        StyledDivRoot: {
            width: "10em",
            position: "relative",
            backgroundColor: "var(--primary-04)",
            BorderBottom: "1px solid var(--primary-02)",
        },
        StyledDivDetail: {
            width: "100%",
            padding: "0 40px 6px 16px",
            display: "flex",
            alignItems: "center",
            userSelect: "none",
            overflow: "hidden",
            wordBreak: "break-all",
            cursor: "pointer",
        },
        StyledDivSummary: {
            width: "100%",
            height: "calc(100% - 20px)",
            minHeight: "50px",
            display: "flex",
            alignItems: "center",
            padding: "0 40px 0 16px",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflowWrap: "anywhere",
            cursor: "pointer",
        },
        StyledImg: {
            width: "30px",
            height: "30px",
            position: "absolute",
            right: "3px",
            top: "calc(50% - 35px)",
            cursor: "pointer",
        },
    })
);

function FList({ id, slideTitle, description, deleteClick, editClick, ...props }: FListProps) {
    const classes = useStyles();
    return (
        <>
            <div className={classes.StyledDivRoot} id={id} {...props}>
                <div className={classes.StyledDivDetail} onClick={() => editClick(id)}>
                    {slideTitle}
                </div>
                <div className={classes.StyledDivSummary} onClick={() => editClick(id)}>
                    {description}
                </div>
                <img
                    className={classes.StyledImg}
                    src={require("../../../assets/image/DeleteIcon.svg").default}
                    alt={"Delete"}
                    onClick={() => deleteClick(id)}
                />
            </div>
        </>
    );
}

export default FList;
